"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ManualSortIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ManualSortIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.29289 4.29289C6.68342 3.90237 7.31658 3.90237 7.70711 4.29289L9.70711 6.29289C10.0976 6.68342 10.0976 7.31658 9.70711 7.70711C9.31658 8.09763 8.68342 8.09763 8.29289 7.70711L8 7.41421V10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10V7.41421L5.70711 7.70711C5.31658 8.09763 4.68342 8.09763 4.29289 7.70711C3.90237 7.31658 3.90237 6.68342 4.29289 6.29289L6.29289 4.29289ZM13 5C12.4477 5 12 5.44772 12 6C12 6.55228 12.4477 7 13 7H19C19.5523 7 20 6.55228 20 6C20 5.44772 19.5523 5 19 5H13ZM15 9C14.4477 9 14 9.44772 14 10C14 10.5523 14.4477 11 15 11H19C19.5523 11 20 10.5523 20 10C20 9.44772 19.5523 9 19 9H15ZM12 14C12 13.4477 12.4477 13 13 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H13C12.4477 15 12 14.5523 12 14ZM15 17C14.4477 17 14 17.4477 14 18C14 18.5523 14.4477 19 15 19H19C19.5523 19 20 18.5523 20 18C20 17.4477 19.5523 17 19 17H15ZM9.70711 17.7071L7.70711 19.7071C7.31658 20.0976 6.68342 20.0976 6.29289 19.7071L4.29289 17.7071C3.90237 17.3166 3.90237 16.6834 4.29289 16.2929C4.68342 15.9024 5.31658 15.9024 5.70711 16.2929L6 16.5858V14C6 13.4477 6.44772 13 7 13C7.55228 13 8 13.4477 8 14V16.5858L8.29289 16.2929C8.68342 15.9024 9.31658 15.9024 9.70711 16.2929C10.0976 16.6834 10.0976 17.3166 9.70711 17.7071Z" })
  );
}